import * as React from 'react';
import { colors } from '@styleseat/brand';

type CheckMarkIconProps = {
  width?: number,
  height?: number,
  color?: string,
} & React.SVGProps<SVGSVGElement>;

export const CheckMarkIcon = ({
  width,
  height,
  color,
  ...restProps
}: CheckMarkIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.66264 6.33751L9.0835 0.916656L9.90845 1.74161L3.66264 7.98743L0.333496 4.65828L1.15845 3.83332L3.66264 6.33751Z"
      fill={color}
    />
  </svg>
);

CheckMarkIcon.defaultProps = {
  width: 14,
  height: 14,
  color: colors.blackInBlack,
};

export default CheckMarkIcon;
